import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/ev_charging_station_daily_settlements',
  component: Management,
  redirect: '/ev_charging_station_daily_settlements/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/ev_charging_station_daily_settlements/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvChargingStationSettlements
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/ev_charging_station_daily_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
